import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g({},on),[_c(VBtn,_vm._g(_vm._b({attrs:{"fab":"","disabled":_vm.isDisabled},on:{"click":_vm.Clicked}},'v-btn',attrs,false),on),[_c(VIcon,{attrs:{"dark":""}},[_vm._v(" "+_vm._s(_vm.buttonIcon)+" ")])],1)],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }